import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivateApartmentIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivateApartmentIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.7977 16.0357C11.5182 16.0357 11.2905 15.8094 11.2905 15.53V13.7345C11.2905 13.455 11.5182 13.2278 11.7977 13.2278C12.0771 13.2278 12.3043 13.455 12.3043 13.7345V15.53C12.3043 15.8094 12.0771 16.0357 11.7977 16.0357Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7974 13.3264C11.5726 13.3264 11.3896 13.5097 11.3896 13.7345V15.5294C11.3896 15.7541 11.5726 15.9368 11.7974 15.9368C12.0221 15.9368 12.2051 15.7541 12.2051 15.5294V13.7345C12.2051 13.5097 12.0221 13.3264 11.7974 13.3264Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7977 8.03576C11.5245 8.03576 11.2973 7.81434 11.2905 7.54071V5.74325C11.2905 5.46382 11.5182 5.2366 11.7977 5.2366C12.0771 5.2366 12.3043 5.46382 12.3043 5.74325V7.52911C12.3043 7.80854 12.0771 8.03576 11.7977 8.03576Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7974 5.33525C11.5726 5.33525 11.3896 5.5179 11.3896 5.74265V7.53819C11.3946 7.75799 11.5776 7.93692 11.7974 7.93692C12.0221 7.93692 12.2051 7.75365 12.2051 7.5289V5.74264C12.2051 5.51789 12.0221 5.33525 11.7974 5.33525Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7977 12.0396C11.5182 12.0396 11.2905 11.8133 11.2905 11.5339V9.73935C11.2905 9.45992 11.5182 9.2327 11.7977 9.2327C12.0771 9.2327 12.3043 9.45992 12.3043 9.73935V11.5339C12.3043 11.8133 12.0771 12.0396 11.7977 12.0396Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.7974 9.33133C11.5726 9.33133 11.3896 9.51398 11.3896 9.73873V11.5336C11.3896 11.7584 11.5726 11.941 11.7974 11.941C12.0221 11.941 12.2051 11.7584 12.2051 11.5336V9.73873C12.2051 9.51398 12.0221 9.33133 11.7974 9.33133Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.79327 13.0757C6.51384 13.0757 6.28613 12.8485 6.28613 12.5691V10.7745C6.28613 10.4951 6.51383 10.2679 6.79327 10.2679C7.07271 10.2679 7.29992 10.4951 7.29992 10.7745V12.5691C7.29992 12.8485 7.0727 13.0757 6.79327 13.0757Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.20067 12.5694V10.7745C7.20067 10.5498 7.01771 10.3665 6.79296 10.3665C6.56821 10.3665 6.38525 10.5498 6.38525 10.7745V12.5694C6.38525 12.7942 6.56821 12.9768 6.79296 12.9768C7.01771 12.9768 7.20067 12.7942 7.20067 12.5694Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4603 8.03576C14.1876 8.03576 13.9609 7.81434 13.9541 7.54071V5.74325C13.9541 5.46382 14.1818 5.2366 14.4612 5.2366C14.7407 5.2366 14.9679 5.46382 14.9679 5.74325V7.53781C14.9616 7.81531 14.7416 8.03383 14.4666 8.03576H14.4603Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4601 7.93691H14.4651C14.6864 7.93443 14.8635 7.75921 14.8685 7.53756V5.74264C14.8685 5.51789 14.6855 5.33524 14.4608 5.33524C14.2357 5.33524 14.0527 5.51789 14.0527 5.74264V7.53818C14.058 7.75922 14.2403 7.93691 14.4601 7.93691Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4608 12.0396C14.1813 12.0396 13.9541 11.8133 13.9541 11.5339V9.73935C13.9541 9.45992 14.1818 9.2327 14.4612 9.2327C14.7407 9.2327 14.9679 9.45992 14.9679 9.73935V11.5339C14.9679 11.8104 14.7431 12.0377 14.4666 12.0396H14.4608Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4604 11.941H14.4651C14.6877 11.9392 14.8685 11.7565 14.8685 11.5336V9.73873C14.8685 9.51398 14.6855 9.33133 14.4608 9.33133C14.2357 9.33133 14.0527 9.51398 14.0527 9.73873V11.5336C14.0527 11.7584 14.2357 11.941 14.4604 11.941Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4608 16.0357C14.1813 16.0357 13.9541 15.8094 13.9541 15.53V13.7345C13.9541 13.455 14.1818 13.2278 14.4612 13.2278C14.7407 13.2278 14.9679 13.455 14.9679 13.7345V15.53C14.9679 15.8065 14.7431 16.0337 14.4666 16.0357H14.4608Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8685 13.7345C14.8685 13.5097 14.6855 13.3264 14.4608 13.3264C14.2357 13.3264 14.0527 13.5097 14.0527 13.7345V15.5294C14.0527 15.7541 14.2357 15.9368 14.4604 15.9368H14.4651C14.6877 15.9343 14.8685 15.7517 14.8685 15.5294V13.7345Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3318 16.2271C19.0524 16.2271 18.8252 15.9999 18.8252 15.7204V13.9259C18.8252 13.6464 19.0524 13.4192 19.3318 13.4192C19.6113 13.4192 19.8385 13.6464 19.8385 13.9259V15.7204C19.8385 15.996 19.6137 16.2242 19.3381 16.2271H19.3318Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3315 16.1282H19.3362C19.5585 16.1257 19.7392 15.9425 19.7392 15.7202V13.9259C19.7392 13.7011 19.5563 13.5179 19.3315 13.5179C19.1068 13.5179 18.9238 13.7011 18.9238 13.9259V15.7202C18.9238 15.9449 19.1068 16.1282 19.3315 16.1282Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3318 20.2232C19.0524 20.2232 18.8252 19.996 18.8252 19.7165V17.921C18.8252 17.6416 19.0524 17.4153 19.3318 17.4153C19.6113 17.4153 19.8385 17.6416 19.8385 17.921V19.7165C19.8385 19.9921 19.6137 20.2203 19.3381 20.2232H19.3318Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3315 20.1243H19.3362C19.5585 20.1218 19.7392 19.9385 19.7392 19.7163V17.9213C19.7392 17.6966 19.5563 17.5139 19.3315 17.5139C19.1068 17.5139 18.9238 17.6966 18.9238 17.9213V19.7163C18.9238 19.941 19.1068 20.1243 19.3315 20.1243Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.0695 22.1567C5.79007 22.1567 5.56285 21.9304 5.56285 21.651C5.56285 21.3715 5.79007 21.1443 6.0695 21.1443H8.68785V8.82026H4.94983V12.9886C4.94983 13.268 4.72213 13.4952 4.44269 13.4952C4.16325 13.4952 3.93604 13.268 3.93604 12.9886V8.31167C3.93604 8.03224 4.16326 7.80502 4.44269 7.80502H8.68785V3.23837C8.68785 2.9628 8.90395 2.73945 9.18 2.73172H17.0786C17.358 2.73172 17.5857 2.95894 17.5857 3.23837V11.2269H21.5829C21.8623 11.2269 22.0895 11.4541 22.0895 11.7335V20.3718C22.0847 21.3551 21.2812 22.1557 20.2974 22.1567L6.0695 22.1567ZM20.2974 21.153C20.7267 21.152 21.0762 20.8011 21.0762 20.3718V12.2392H17.5876V21.153H20.2974ZM16.5719 21.1443V3.73632H9.691V21.1443H11.2907V17.9042C11.2907 17.6248 11.5184 17.3976 11.7979 17.3976H14.4612C14.7406 17.3976 14.9678 17.6248 14.9678 17.9042V21.1443H16.5719ZM13.9584 21.1443V18.4109H12.3045V21.1443H13.9584Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5829 11.3261H17.4866V3.23935C17.4866 3.0146 17.3036 2.83133 17.0789 2.83133H9.18311C8.96052 2.83814 8.78685 3.01708 8.78716 3.23935V7.90405H4.44287C4.21812 7.90405 4.03516 8.08732 4.03516 8.31207V12.9891C4.03516 13.2139 4.21812 13.3972 4.44287 13.3972C4.66762 13.3972 4.85058 13.2139 4.85058 12.9891V8.72195H8.78716V21.2437H6.0697C5.84495 21.2437 5.66199 21.427 5.66199 21.6517C5.66199 21.8765 5.84495 22.0591 6.0697 22.0591H20.2975C21.2266 22.0579 21.986 21.3013 21.9906 20.3725V11.7341C21.9906 11.5094 21.8076 11.3261 21.5829 11.3261ZM21.1752 12.1415V20.3725C21.1752 20.8567 20.7814 21.2511 20.2975 21.2524H17.4887V12.1415H21.1752ZM14.0574 18.3126V21.2437H12.2055V18.3126H14.0574ZM14.4611 17.4972H11.7978C11.573 17.4972 11.3901 17.6805 11.3901 17.9052V21.2437H9.59176V3.6387H16.6712V21.2437H14.8688V17.9052C14.8688 17.6805 14.6858 17.4972 14.4611 17.4972Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.49838 22.1686C4.21895 22.1686 3.99173 21.9414 3.99173 21.662V19.6702C2.88463 19.384 2.08936 18.2015 2.08936 16.8217C2.08936 15.1954 4.22958 13.9819 4.25134 13.9703C4.32386 13.9278 4.4099 13.9046 4.49742 13.9046C4.58589 13.9046 4.67291 13.9278 4.74978 13.9732C4.76718 13.9819 6.90741 15.2041 6.90741 16.8217C6.90741 18.1966 6.11213 19.384 5.00553 19.6798V21.662C5.00553 21.9414 4.77782 22.1686 4.49838 22.1686ZM4.49838 15.0088C4.16819 15.235 3.10315 16.024 3.10315 16.8217C3.10315 17.6068 3.46235 18.3098 3.99173 18.5911V17.9046C3.99173 17.6252 4.21895 17.398 4.49838 17.398C4.77781 17.398 5.00552 17.6252 5.00552 17.9046V18.5911C5.5349 18.3088 5.89361 17.6068 5.89361 16.8217C5.89361 16.0231 4.82857 15.2341 4.49838 15.0088Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.80829 16.8211C6.80829 15.2547 4.71958 14.069 4.69945 14.0578C4.57562 13.9854 4.42176 13.9848 4.29855 14.0572C4.2775 14.069 2.18848 15.2547 2.18848 16.8211C2.18848 18.1919 2.98688 19.3516 4.09083 19.5918V21.6617C4.09083 21.8864 4.27379 22.0697 4.49854 22.0697C4.72329 22.0697 4.90625 21.8864 4.90625 21.6617V19.6024C6.00989 19.3516 6.80829 18.187 6.80829 16.8211ZM4.49854 17.4966C4.27379 17.4966 4.09083 17.6799 4.09083 17.9046V18.7448C3.44877 18.5015 3.00391 17.7183 3.00391 16.8211C3.00391 15.9271 4.21095 15.0794 4.49855 14.89C4.78615 15.0794 5.99288 15.9271 5.99288 16.8211C5.99288 17.7183 5.54833 18.5009 4.90627 18.7448V17.9046C4.90627 17.6799 4.72329 17.4966 4.49854 17.4966Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PrivateApartmentIcon;
